import { useOrganisation } from "@/features/select-organisation/api/get-my-organisation";
import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import {
  PublicSession,
  UpdateRecurringSessionDto,
  UpdateSessionDto,
} from "@classview/shared-types";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";

const updateSession = async ({
  orgId,
  id,
  session,
}: {
  orgId: string;
  id: string;
  session: UpdateSessionDto;
}): Promise<PublicSession> => {
  // yes, you need to pass the id in the url before the resource name
  const response = await axiosClient.patch(`${orgId}/sessions/${id}`, {
    ...session,
    guests: session.guests?.map((guest) => guest.toLowerCase().trim()),
  });
  return response.data;
};

function useUpdateSession(
  mutationOptions?: UseMutationOptions<
    PublicSession,
    HttpError,
    { id: string; session: UpdateSessionDto }
  >,
) {
  const { organisation } = useOrganisation();
  return useMutation({
    mutationFn: (data) => updateSession({ ...data, orgId: organisation.id }),
    ...mutationOptions,
  });
}

const updateRecurringSession = async ({
  orgId,
  id,
  session,
}: {
  orgId: string;
  id: string;
  session: UpdateRecurringSessionDto;
}): Promise<PublicSession[]> => {
  // yes, you need to pass the id in the url before the resource name
  const response = await axiosClient.patch(
    `${orgId}/sessions/sessions-recurring/${id}`,
    {
      ...session,
      guests: session.guests?.map((guest) => guest.toLowerCase().trim()),
    },
  );
  return response.data;
};

function useUpdateRecurringSession(
  mutationOptions?: UseMutationOptions<
    PublicSession[],
    HttpError,
    { id: string; session: UpdateRecurringSessionDto }
  >,
) {
  const { organisation } = useOrganisation();
  return useMutation({
    mutationFn: (data) =>
      updateRecurringSession({ ...data, orgId: organisation.id }),
    ...mutationOptions,
  });
}

export { useUpdateRecurringSession, useUpdateSession };
